<template>
  <Card>
    <FlexCol>
      <div class="flex flex-wrap items-start justify-between gap-4">
        <FlexCol class="min-w-[280px] gap-2">
          <TheBreadcrumb v-if="showBreadcrumb" />
          <h1 class="text-xl font-semibold leading-tight tracking-[-0.4px] text-[#13161b] md:text-[38px]">
            {{ title }}
          </h1>
          <p v-if="subtitle" class="text-[16px] leading-6 tracking-[-0.16px] text-slate-600">
            {{ subtitle }}
          </p>
        </FlexCol>

        <div v-if="$slots.actions" class="flex shrink-0 flex-wrap items-center justify-end gap-3 self-start">
          <slot name="actions"></slot>
        </div>
      </div>
    </FlexCol>
  </Card>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  breadcrumb: {
    type: Boolean,
    default: true,
  },
})

const route = useRoute()

const showBreadcrumb = computed(() => {
  if (!props.breadcrumb) return false
  return Array.isArray(route.meta?.breadcrumb) && route.meta.breadcrumb.length > 0
})
</script>
